import { UserRole } from '@core-lib/enums';
import { UserPermission } from '@core-lib/enums/user-permission.enum';
import { IUser, IUserLight } from '@core-lib/models';

export function userHasRole(userRoles: UserRole[], role: UserRole | string) {
	return userRoles.some(p => p == role);
}

export function hasUserRole(utilisateur:IUser | IUserLight | any, role: UserRole | string): boolean {
	return (
		(utilisateur?.roleGroupe && (utilisateur?.roleGroupe?.some(r => r.code === role) || utilisateur?.roleGroupe?.code === role)) ||
		(utilisateur?.roles && (utilisateur?.roles?.some(r => r.code === role) || utilisateur?.roles?.code === role || utilisateur?.roles?.some(r => r === role)))
	);
}

export function userHasAnyPermission(userPermissions: UserPermission[], permissions: UserPermission[]): boolean {
	return permissions.some(permission => userHasPermission(userPermissions, permission));
}

export function userHasPermission(userPermissions: UserPermission[], permission: UserPermission): boolean {
	return userPermissions?.some(p => p === permission);
}
